import { isBrowser } from './isBrowser';

// README: https://docs.fiverr-gw.com/platform/perseus/migration/migrating_from_v2#no-more-window-over-node
export const getWindow = (): undefined | Window => (isBrowser() ? window : undefined);

export const getDocument = () => getWindow()?.document;
